var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stripe-payment-wrapper"},[_c('div',{attrs:{"id":_vm.elementId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }